<ng-container *ngIf="loading">
  <div class="flex justify-center m-2">
    <div class="w-[95%] lg:w-9/12 mb-7">
      <div class="mb-3">
        <div class="md:mb-10 mb-2">
          <div class="flex items-center text-base font-semibold text-[#3246D3]">
            <div
              class="me-2 w-[24px] h-[6px] inline-block bg--blue rounded-[5px]"
            ></div>

            <ng-container *ngIf="isMoneyManagment">
              <h3 class="mt-1.5 text-[#3246D3] text-xl"> نظرات کاربران ایرانی اکسپرت</h3>
            </ng-container>
            <ng-container *ngIf="!isMoneyManagment">
              <h4 class="mt-1.5 text-[#3246D3]"> نظرات کاربران ایرانی اکسپرت</h4>
            </ng-container>

          </div>
          <p class="sm:text-[27px] text-xl font-bold mt-1 text-black">
            لطفا نظرات خود را درباره این مطلب ثبت کنید
          </p>
        </div>
        <form [formGroup]="form" (ngSubmit)="commentServices()">
          <div class="flex flex-col items-center">
            <div class="" *ngIf="!isLogin">
              <p (click)="openModal()" class="cursor-pointer warning-login">لطفا وارد حساب کاربری خود شوید</p>
            </div>
            <div
              class="flex md:w-[46rem] justify-between max-lg:flex-col max-lg:items-center"
            >
              <div
                class="sep-part"
                [ngClass]="this.formErrors['NameInfo'] != null ? 'hasError' : ''"
              >
                <label for="submit-data"></label>        
                <input
                  readonly
                  aria-label="submit-data"
                  type="text"
                  id="submit-data"
                  name="submit-data"
                  [ngClass]="completedFill ? 'disable-color' : ''"
                  formControlName="NameInfo"
                  class="!w-48"
                />
                <div
                  class="w-[16rem] flex items-center font-bold md:text-xl text-lg pr-3"
                >
                  نام و نام خانوادگی
                </div>
              </div>
              <div
                class="sep-part max-lg:w-full max-md:mt-6"
                [ngClass]="this.formErrors['Email'] != null ? 'hasError' : ''"
              >
                <label for="submit-data"></label>        
                <input
                  type="text"
                  id="submit-data"
                  aria-label="submit-data"
                  name="submit-data"
                  [ngClass]="completedFill ? 'disable-color' : ''"
                  formControlName="Email"
                  class="!w-[65%]"
                  readonly
                />
                <div
                  class="w-[5rem] flex items-center font-bold md:text-xl text-lg"
                >
                  ایمیل
                </div>
              </div>

            </div>
  
            <div class="w-full mt-5">
              <textarea
                [ngClass]="this.formErrors['textAr'] != null ? 'hasError' : ''"
                formControlName="textAr"
                placeholder="نظر خود را درباره مطلب ارائه شده ثبت کنید"
              ></textarea>
            </div>
  
            <div class="flex flex-col w-full">
              <div class="w-full flex justify-between max-md:flex-col-reverse">
                <div class="flex flex-col mt-4">
                  <span class="font-bold me-2">امتیاز دهید:{{ rateText }}</span>
                  <span>برداشت خود را در بررسی مطلب ارائه شده ثبت کنید</span>
                </div>
                <!-- <div class="flex items-center max-md:mb-4">
                  ثبت نظر به صورت ناشناس <app-toggle class="mr-3"></app-toggle>
                </div> -->
              </div>
              <div class="lg:flex">
                <div class="flex flex-col w-full justify-center">
                  <div
                    class="p-div lg:w-[18rem] flex flex-col p-2 text-2xl mb-[24px] justify-center"
                  >
                    <div class="flex flex-col">
                      <div class="flex flex-row-reverse max-md:justify-around">
                        <div
                          class="flex justify-center mx-2 w-9 cursor-pointer"
                          [ngClass]="rate == 1 ? 'bg-active' : ''"
                        >
                          <i
                            class="ie-h1 mx-1"
                            (click)="putStyle(1, 'خیلی بد ')"
                          ></i>
                        </div>
                        <div
                          class="flex justify-center mx-2 w-9 cursor-pointer"
                          [ngClass]="rate == 2 ? 'bg-active' : ''"
                        >
                          <i class="ie-h2 mx-1" (click)="putStyle(2, 'بد')"></i>
                        </div>
                        <div
                          class="flex justify-center mx-2 w-9 cursor-pointer"
                          [ngClass]="rate == 3 ? 'bg-active' : ''"
                        >
                          <i class="ie-h3 mx-1" (click)="putStyle(3, 'خوب')"></i>
                        </div>
                        <div
                          class="flex justify-center mx-2 w-9 cursor-pointer"
                          [ngClass]="rate == 4 ? 'bg-active' : ''"
                        >
                          <i
                            class="ie-h4 mx-1"
                            (click)="putStyle(4, 'خیلی خوب')"
                          ></i>
                        </div>
                        <div
                          class="flex justify-center mx-2 w-9 cursor-pointer"
                          [ngClass]="rate == 5 ? 'bg-active' : ''"
                        >
                          <i class="ie-h5 mx-1" (click)="putStyle(5, 'عالی')">
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="flex flex-col w-full lg:w-fit max-md:items-center items-end justify-end mb-4"
                >
                  <button
                    name="submit-comment"
                    type="submit"
                    aria-label="ثبت دیدگاه"
                    class="rounded-xl bg-[#3246d3] border-solid text-white font-black sm:w-[13.5rem] w-[12rem] mr-2 p-4"
                  >
                    ثبت دیدگاه
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        <ng-container *ngFor="let comment of preComments">
          <div class="flex flex-col items-end max-w-[736px]"  *ngIf="!comment.parentID">
            <div
              class="w-full border-solid border-2 border-gray-300 rounded-lg mb-6 mt-8"
            >
              <div
                class="flex justify-between border-b-2 m-2 py-2 sm:mx-8 border-gray-300"
              >
                <div class="flex justify-around items-center text-xs">
                  <div class="point-card font-extrabold">{{ comment.rate }}</div>
                  <p class="font-bold sm:leading-[20px] mx-2 pt-2 text-[#847b7b]">
                    {{ comment.createDate | date : "MMMM d" }}
                  </p>
                  <p class="font-bold sm:leading-[20x] mx-2 pt-2 text-[#847b7b]">
                    {{ comment.name }}
                  </p>
                  <div
                    class="rounded-full flex text-[#17ee9d] items-center text-base bg-gray-100 px-6 ms-1 sm:mt-2 py-4 font-bold max-md:hidden sm:h-[36%]"
                  >
                    کاربر
                  </div>
                </div>
                <div class="w-1/4 flex justify-end">
                  <i
                    class="fa fa-ellipsis-v leading-[44px] text-xl text-gray-400"
                  ></i>
                </div>
              </div>
              <div class="sm:h-[48%] flex m-2 sm:mx-8 pt-2 items-center pb-4">
                <img
                  loading="lazy"
                  src="../../../assets/img/avatar-c-2.webp"
                  class="ml-3 h-12 w-12 bg-[#e8e8e8] rounded-full"
                  alt="avatar"
                  width="10"
                  height="20"
                  loading="lazy"
                />
                <p class="sm:leading-[3.4rem] ms-2 font-medium text-sm md:text-base">
                  {{ comment.text }}
                </p>
              </div>
              <!-- <div class="h-1/4 sm:m-2 mx-8">
                <span class="text-[#0f9260]"
                ><i class="fa fa-thumbs-up text-lg cursor-pointer"></i> 27+</span
                >
                <i class="fa fa-thumbs-down text-gray-400 text-lg cursor-pointer"></i>
              </div> -->
              <ng-container *ngIf="comment.commentParent">
                <div class="reply-row-x"></div>
                <div class="reply-row-y"></div>
              </ng-container>
            </div>
            <!-- ========[ریپلای کامنت]=========== -->
            <ng-container *ngFor="let replyComment of comment.commentParent">

              <div class="flex flex-col bg-[#E9F6FF] border-solid border-2 border-gray-300 rounded-lg px-6 py-4 w-[87%] md:w-[95%]">
                <div class="flex items-center border-b-2 pb-4">
                  <p class="text-[#8F8F8F] font-medium ml-6 text-xs md:text-base">{{replyComment.createDate | date : "MMMM d"}}</p>
                  <p class="text-white font-bold bg-[#17C9EE] rounded-3xl px-3 py-2 md:px-4 md:py-2 text-xs md:text-sm">پشتیبان ایرانی اکسپرت</p>
                </div>
                <div class="flex items-center pt-4 pb-2">
                  <img class="ml-4 md:w-12 aspect-square w-9" src="../../../assets/img/avatar-c.webp" alt="avatar-img" loading="lazy">
                  <p class="text-black font-medium text-xs md:text-base">
                    {{replyComment.text}}
                  </p>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
